import { HubConnection, HubConnectionBuilder, HubConnectionState } from '@microsoft/signalr'
import 'firebase/auth' // Import Firebase auth module
import { getAuth, getIdToken, User } from 'firebase/auth'

import { createContext, useContext, useEffect, useMemo, useRef, useState } from 'react'
// import { createSignalRContext } from 'react-signalr/signalr'

import { API_BASE_URL } from '@apps-common/config'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'
import { useIonViewWillLeave } from '@ionic/react'

// export const SignalRContext = createSignalRContext()

type ISignalRContext = {
  status: HubConnectionState
  setIdentifier: (unit: IUnitGenericDetailsModel) => void
  setIdentifierStr: (str: string) => void
  connect: () => void
  connection: HubConnection | undefined
}

const SignalRContext = createContext<ISignalRContext>({
  status: HubConnectionState.Disconnected,
  setIdentifier: (unit: IUnitGenericDetailsModel) => null,
  setIdentifierStr: (str: string) => null,
  connect: () => {},
  connection: undefined
})

export const SignalRProvider = ({ children }: any) => {
  const [status, setStatus] = useState<HubConnectionState>(HubConnectionState.Connecting)
  const [token, setToken] = useState<string | null>(null)
  const [identifier, setIdentifier] = useState<string>()
  // const [connection, setConnection] = useState<HubConnection>()
  const connectionStateRef = useRef<HubConnection | undefined>(undefined)
  // connection.on('Connected', () => {
  //   console.log('SignalR Connected event received.')
  //   setStatus(HubConnectionState.Connected)
  // })

  useIonViewWillLeave(() => {
    // *** This is where you should dispose of resources or reset context-specific state ***
    console.log('Page is leaving, running cleanup...')
    // Example: Resetting a specific part of the context state related to this page
    if (connectionStateRef.current) {
      console.log('useIonViewWillLeave -> Stopping HubConnection')

      connectionStateRef.current
        .stop()
        .then(() => console.log('Connection stopped.'))
        .catch((err) => console.error('Error while stopping connection: ' + err))
      connectionStateRef.current = undefined
      setStatus(HubConnectionState.Disconnected)
    } else {
      console.log('useIonViewWillLeave -> No HubConnection to stop')
    }
    // Example: Unsubscribe from an observable (if you have one)
    // mySubscription.unsubscribe();
  })

  // useEffect(() => {
  //   // const authSub = getAuth().onAuthStateChanged((user) => {
  //   //   refreshToken(user)
  //   // })

  //   connection.onreconnecting(() => {
  //     console.log('Reconnecting...')
  //   })

  //   connection.onreconnected(() => {
  //     console.log('Reconnected...')
  //   })

  //   connection.onclose(() => {
  //     console.log('Connection closed...')
  //   })

  //   // Cleanup subscription on unmount
  //   // return () => authSub()
  // }, [])

  const refreshToken = async (user: User | null) => {
    try {
      if (!user) {
        setToken(null)

        return
      }

      const tokenResult = await getIdToken(user)

      setToken(tokenResult)
    } catch {
      setToken(null)
    }
  }

  useEffect(() => {
    const unsubscribe = getAuth().onAuthStateChanged((user) => {
      refreshToken(user)
    })

    // Cleanup subscription on unmount
    return () => unsubscribe()
  }, [])

  const connect = () => {
    if (identifier && identifier?.length > 0 && token) {
      if (connectionStateRef.current) {
        connectionStateRef.current.stop()
      }

      let hubConnection: HubConnection = new HubConnectionBuilder()
        .withUrl(`${API_BASE_URL}/hub/trafficstream?identifier=${identifier}`, {
          accessTokenFactory: async () => {
            // let token
            // try {
            //   const auth = getAuth()
            //   token = await auth?.currentUser?.getIdToken()
            // } catch (error) {
            //   console.error('Error getting ID token:', error)
            // }

            // console.log('Using token:', token)

            return token || ''
          }
        })
        .withAutomaticReconnect() // Optional: Configure automatic reconnection
        .build()

      hubConnection?.onreconnecting(() => {
        setStatus(HubConnectionState.Reconnecting)
        console.log('Connection State...Reconnecting...')
      })

      hubConnection?.onreconnected(() => {
        setStatus(HubConnectionState.Connected)
        console.log('Connection State...Reconnected...')
      })

      hubConnection?.onclose(() => {
        setStatus(HubConnectionState.Disconnected)
        console.log('Connection State...Connection closed...')
      })

      hubConnection
        .start()
        .then(() => {
          console.log('SignalR Connected.')
          setStatus(HubConnectionState.Connected)
        })
        .catch((err) => {
          setStatus(HubConnectionState.Disconnected)
        })

      connectionStateRef.current = hubConnection
    }
  }

  useEffect(() => {
    // setStatus(HubConnectionState.Connecting)
    console.log('Connection State...Token', token)
    connect()

    return () => {
      console.log('useEffect -> Stopping HubConnection')
      connectionStateRef.current?.stop()
    }
  }, [identifier, token])

  useEffect(() => {
    console.log('Connection State...', status)
  }, [status])

  const value = useMemo(
    () => ({
      status,
      setIdentifier: (unit: IUnitGenericDetailsModel) => setIdentifier(`${unit.ipAddress},${unit.imei}`),
      setIdentifierStr: (str: string) => setIdentifier(str),
      connect,
      connection: connectionStateRef.current
    }),
    [status]
  )

  return (
    <SignalRContext.Provider
      // connectEnabled={!!token && !!identifier}
      // accessTokenFactory={() => token || ''}
      // dependencies={[token]} // remove previous connection and create a new connection if changed
      // url={`${API_BASE_URL}/hub/trafficstream?identifier=${identifier}`}
      // onError={async (e) => {
      //   console.log(e)
      //   setStatus(HubConnectionState.Disconnected)
      // }}
      // onReconnect={() => setStatus(HubConnectionState.Connected)}
      // onOpen={() => setStatus(HubConnectionState.Connected)}
      // onClosed={() => setStatus(HubConnectionState.Disconnected)}
      // automaticReconnect
      value={value}
    >
      {children}
    </SignalRContext.Provider>
  )
}

export const useSignalR = () => useContext(SignalRContext)
